import * as types from '../actions/action-types';
import { coachType, timeFilter, amenFilter } from '../common/filters';

const initialState = {
	data: [],
	editOptions: [],
	seatChart: [],
	buses: [],
	filter: [],
	prepostfilter: [],
	pickups: [],
	dropPoints: [],
	finalSave: false,
	editDetails: [],
	oldSeats: [],
	stChrtStatus: {},
	stChrtOthrDtls: {},
	header: {},
	order: [],
	reschedulecharge: {},
	olddata: [],
	currency: window.location.hostname === 'busdemo.travels.com.mm' ? 'K' : '₹',
	newDepartDate: '',
};

const editPolicyReducer = function (state = initialState, action) {
	let order = state.order;
	let currState = state;
	let buses;
	let stChrtStatus = state.stChrtStatus;
	let stChrtOthrDtls = state.stChrtOthrDtls;
	let header = state.header;
	switch (action.type) {
		case types.GET_EDITPOLICY_RES:
			return Object.assign({}, state, {
				data: action.data
			});
		case types.GET_EDITPOLICY_DATA:
			return Object.assign({}, state, {
				olddata: action.data
			});
		case types.TOGGLE_FINAL_SAVE:
			return Object.assign({}, state, {
				finalSave: action.data
			});
		case types.GET_EDITPOLICY_OPT:
			return Object.assign({}, state, {
				editOptions: action.data
			});
		case types.GET_SEATCHART_DETAIL:
			return Object.assign({}, state, {
				seatChart: action.data
			});
		case types.GET_SEARCH_RES:
			const disBuses = action.data ? getDiscount(action.data) : false;
			return Object.assign({}, state, {
				buses: disBuses
			});
		case types.GET_CHECKBOX_RES:
			return Object.assign({}, state, {
				filter: action.data
			});
		case types.GET_PREPOST_CHECKBOX_RES:
			return Object.assign({}, state, {
				prepostfilter: action.data
			});
		case types.UPDATE_ROUTE_INFO:
			return Object.assign({}, state, {
				pickups: action.data.pickups,
				dropPoints: action.data.dropPoints
			});
		case types.SAVE_EDIT_DETAILS:
			return Object.assign({}, state, {
				editDetails: action.data
			});
		case types.GET_OLD_SEAT:
			return Object.assign({}, state, {
				oldSeats: action.data
			});
		case types.UPDATE_SEAT_CHART:
			stChrtStatus[action.rsid] = action.data;
			return Object.assign({}, state, {
				stChrtStatus
			});
		case types.UPDATE_SEAT_CHART_DET:
			stChrtOthrDtls[action.rsid] = action.data;
			return Object.assign({}, state, {
				stChrtOthrDtls
			});
		case types.UPDATE_CHECKOUT_DET:
			return Object.assign({}, state, {
				order: action.data
			});
		case types.UPDATE_HEADER_TEXT:
			header[action.text] = action.data;
			header[action.text1] = action.data1;
			header[action.text2] = action.data2;

			return Object.assign({}, state, {
				header
			});
		case types.UPDATE_FILTER_RESET:
			currState.time = [];
			currState.amenities = [];
			currState.coach = [];
			buses = parseFilter(currState);
			return Object.assign({}, state, {
				time: [],
				amenities: [],
				coach: [],
				buses
			});
		case types.UPDATE_USER_GENDER:
			order[action.param].seatDetails[action.seat].gender = action.data;
			return Object.assign({}, state, {
				order
			});
		case types.GET_RESCHEDULE_CHARGES:
			return Object.assign({}, state, {
				reschedulecharge: action.data
			});
		case types.SET_NEW_DEPART_DATE:
			return Object.assign({}, state, {
				newDepartDate: action.data
			});
		default:
			return state
	}
}

const getDiscount = (val) => {
	if (val.DiscountAmt > 0) {
		val['DiscFare'] = val.Fare - val.DiscountAmt;
	} else if (val.DiscountPer > 0) {
		val['DiscFare'] = Math.round(val.Fare - (val.Fare * val.DiscountPer / 100));
	} else {
		val['DiscFare'] = val.Fare;
	}
	return val;
}

const parseFilter = (st) => {
	const loop = st.data;
	let buses = [];
	for (let i = 0; i < loop.length; i++) {
		const val = timeFilter(loop[i], st.time) && coachType(loop[i], st.coach, st.staticData.coach) &&
			amenFilter(loop[i], st.amenities, st.allAmen);
		if (val) {
			buses.push(loop[i]);
		}
	}
	return buses;
}

export default editPolicyReducer;



// WEBPACK FOOTER //
// ./src/reducers/editPolicy-reducer.js